// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RadioButton_wrapper__bYZZE","disabled":"RadioButton_disabled__xFgkT"};